import "./App.css";

import { BrowserRouter as Router, Routes } from "react-router-dom";


import { HelmetProvider } from "react-helmet-async";

/* Rutas */
import PublicRoutes from "./routes/public-routes";
import AdminRoutes from "./routes/admin-routes";

/* Provedores */
import MasterProvider from "./providers/MasterProvider";
import AuthProvider from "./context/auth/AuthContext";
import StoreProvider from "./resource/providers/StoreProvider";
import { ContextProvider } from "./resource/context/ContextProvider";
import EventosState from "./context/EventosState";

function App() {
  return (
    <HelmetProvider>
      <MasterProvider>
        <AuthProvider>
          <StoreProvider>
            <ContextProvider>
              <EventosState>
                <Router>
                  <Routes>
                    {AdminRoutes}
                    {PublicRoutes}
                  </Routes>
                </Router>
              </EventosState>
            </ContextProvider>
          </StoreProvider>
        </AuthProvider>
      </MasterProvider>
    </HelmetProvider>
  );
}

export default App;
